<template lang="html">
  <div class="koltsegvetes">
    <h1>Költségvetésünk</h1>
    <h3>Nézd meg, mire költjük a pénzed!</h3>
    <div class="koltsegvetes--year">
      <h3>2019</h3>
      <ul>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
      </ul>
    </div>

    <div class="koltsegvetes--year">
      <h3>2018</h3>
      <ul>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
        <li>
          <a href="#">Link a google dokumentumhoz</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.koltsegvetes--year{
  margin: 20px auto;
  max-width: 300px;

  h3{
    text-align: left;
    margin-left: 15px;
  }
  ul{
    padding-left: 0;
    list-style-type: none;

    a{
      text-decoration: none;
    }
  }
}
</style>
